import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { bookingsUoUFlowBookInitialIntentSrc16Evid33 } from '@wix/bi-logger-bookings-data/v2';
import { bookingsLoginUserAccountSeeAllServicesClick } from '@wix/bi-logger-wixboost-ugc/v2';
import { GUID } from '@wix/bi-logger-wixboost-ugc/v2/types';
import { navigateToCalendarPage } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { settingsDefaults, widgetDefaults } from '../../core/bi/consts';
import { BookingsGroup, MemberAreaClickActions } from '../../types';
import { CreateActionParams } from '../actions';

export type ClickOnBookAgain = (args: { group: BookingsGroup }) => void;

export function createClickOnBookAgainAction({
  getControllerState,
  context,
}: CreateActionParams): ClickOnBookAgain {
  return async ({ group }) => {
    const { flowAPI, biLogger } = context;
    const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
    const [state] = getControllerState();
    const service = group.bookings[0].service;
    const slug = service?.mainSlug?.name;

    const serviceType =
      service?.type === ServiceType.APPOINTMENT ? 'ind' : 'class';

    biLogger?.report(
      bookingsLoginUserAccountSeeAllServicesClick({
        extraInfo: JSON.stringify({
          type: serviceType,
        }),
        action: MemberAreaClickActions.BookAgain,
        referralInfo: state.selectedTab.type,
      }),
    );

    biLogger?.report(
      bookingsUoUFlowBookInitialIntentSrc16Evid33({
        widget_name: widgetDefaults.widget_מame,
        serviceType,
        bookingsServiceId: service?.id as GUID,
      }),
    );

    try {
      await navigateToCalendarPage(wixCodeApi, platformAPIs as any, {
        serviceSlugOrBasket: slug,
        navigationContext: {
          referral: settingsDefaults.referralInfo,
        },
      });
    } catch {
      wixCodeApi.location.to?.('/');
    }
  };
}
